export default __webpack_public_path__ + "static/media/abdullah.3fdb6649.png";